import {internalApi} from "../../../firebase/internalApi";
import {Auth} from "../../../firebase/firebase";

export async function makeAdmin(userID) {
    return internalApi("/auth/makeAdmin", {userID});
}

export function checkAdmin() {
    Auth.currentUser.getIdTokenResult()
        .then((idTokenResult) => {
            console.log(idTokenResult.claims.admin);
        })
}
